<template>
<div>
  <div class="row" >
    <div class="col-md-12">
      <h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2>
    </div>
    <div class="col-md-12">
      <add-document @send-file="sendFile"></add-document>
    </div>
  </div>
  <div class="row" style="margin-top: -20px">
    <div class="col-md-12">
      <table-files v-if="docsShown" :files="files" @delete-file="deleteDocument"></table-files>
    </div>
  </div>
</div>
</template>

<script>
  import ProgressBar from "../../components/Progress";
  import AddDocument from "../../components/AddDocument";
  import TableFiles from "../SafetyDocs/TableFiles";
  import NotificationTemplate from "../Notifications/NotificationTemplate";
  import ProjectsFilter from "../../components/Filters/Projects";
  import axios from "axios";
  import {setCookie, url} from "../../plugins/axios";
  export default {
    components: {AddDocument, TableFiles, ProjectsFilter, ProgressBar},
    name: "ProjectsDocuments",
    data(){
      return{
        progressValue: 0,
        current: 0,
        files: [],
        docsShown: false,
        projectName: '',
      }
    },
    methods:{
      notifyVue(type,message) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: type,
          message:message,
          timeout: 1500
        });
      },
      getProjectDocs(id){
        axios
          .get(url + 'documents/' + id + '/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.files = response.data.result;
              this.docsShown = this.files !== null;
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      deleteDocument(id, rowId){
        id = parseInt(id);
        axios
          .put(url + 'delete-documents/' + id + '/',
            {data: {}},
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              $(this.$el).find(rowId).hide();
              this.notifyVue('success','Document was deleted');
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) =>{
            this.notifyVue('danger',error);
          })
      },
      sendFile(file){
        let formData = new FormData(document.getElementById('upLoadFile'));
        file.type = 'documents';
        formData.append('currentDate', file.date);
        formData.append('description', file.description);
        formData.append('file',        file.file);
        formData.append('fileType',    file.type);
        formData.append('project_id',  this.current);
        if (file.file !==''){
          axios
            .post(url + 'upload-file/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                withCredentials:'include',
                crossDomain:true,
              })
            .then((response) => {
              if (response.data.error === ''){
                this.notifyVue('success', 'The file was added');
                this.getProjectDocs(this.current);
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        }
        else{
          this.notifyVue('info','You did not choose the file :(');
        }
      },
    },

    created() {
      const params = this.$route.query;
      this.projectName = params.projectName.split('_').join(' ');
      if (params.projectId > 0){
        this.current = params.projectId;
        this.getProjectDocs(params.projectId);
      }
    },
  }
</script>

<style scoped>
  .delay{
    animation-delay: 4.0s;
  }
</style>
